var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{attrs:{"value":_vm.siderRightVisibility,"app":"","fixed":"","right":""}},[_c('v-container',[_vm._v("\n        Country in charge\n        "),_c('countries')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }